export class ValidationChecker {

  public static checkAllValidation(self: any) {
    if (ValidationChecker.checkMail(self.email)) {
      self.error = self.$t("message.invalidEmail");
      return false;
    }
    if (ValidationChecker.checkID(self.user)) {
      self.error = self.$t("message.IDMustBeSingleByteAlphanumericChars");
      return false;
    }
    if (ValidationChecker.checkPasswordAlphabet(self.password)) {
      self.error = self.$t("message.passwordMustHaveUppercaseLetter");
      return false;
    }
    if (ValidationChecker.checkPasswordNumber(self.password)) {
      self.error = self.$t("message.passwordMustHaveNum");
      return false;
    }
    if (ValidationChecker.checkPasswordLen(self.password)) {
      self.error = self.$t("message.passwordMustHave8Chars");
      return false;
    }
    self.error = "";
    return true;
  }
  private static checkPasswordNumber(pwd: string) {
    return pwd.match(/[0-9]/) === null;
  }

  private static checkPasswordAlphabet(pwd: string) {
    return pwd.match(/[A-Z]/) === null;
  }

  private static checkPasswordLen(pwd: string) {
    return pwd.length < 8;
  }

  private static checkMail(mail: string) {
    return (
      mail.match(
        /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      ) === null
    );
  }

  private static checkID(id: string) {
    return id.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/) === null;
  }
}
